@if (rows().length > 0) {
  <div class="d-flex align-items-top justify-content-between">
    <h6 class="mb-0 font-weight-bold">{{ 'screening.case.screening_case_table_title' | translate }}</h6>
    @if (!isPrintVersion()) {
      <a nkButton color="secondary" size="sm" [routerLink]="screeningEntityUuid() + '/screening-cases'">{{
        'screening.screening_overrides.screening_case_table.open_case_btn' | translate
      }}</a>
    }
  </div>
  <table class="table table-dense table-striped w-100">
    <thead>
      <tr class="sm text-muted">
        <th>{{ 'screening.case.review.supplier.match_name' | translate }}</th>
        <th>{{ 'screening.case.review.supplier.match_score' | translate }}</th>
        <th>{{ 'screening.screening_overrides.screening_case_table.table.date' | translate }}</th>
        <th>{{ 'screening.screening_overrides.screening_case_table.table.status' | translate }}</th>
      </tr>
    </thead>
    <tbody class="small">
      @for (row of rows(); track row.uuid) {
        <tr>
          <td>{{ row.matchName }}</td>
          <td>{{ row.matchScore !== null ? row.matchScore : '-' }}</td>
          <td>{{ row.date ? (row.date | date: dateFormats.Standard) : '-' }}</td>
          <td>
            @if (row.screeningStatusTags.length) {
              @for (statusKey of row.screeningStatusTags; track statusKey) {
                <span class="small tag {{ cssClasses[statusKey] }}">
                  @if (icons[statusKey]) {
                    <i class="fa {{ icons[statusKey] }}"></i>
                  }
                  {{ translations[statusKey] | translate }}
                </span>
              }
            } @else {
              <span>-</span>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
  <hr />
}
